import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useInstitutionOnboardingBasePath } from '@/features/institution/context/update';
import { useInstitutionDetailsV2Answers } from '@/features/institution/hooks/useInstitutionDetails';
import { getV2OnboardingApplicableDetailsKeys, getV2OnboardingDetailsKeyRoute } from '@/features/institution/utils';
import type { InstitutionDetailsV2TaxSelfCertificationKey } from '@/services/api/profile';

const OTHER_TAX_SELF_CERTIFICATION: Record<InstitutionDetailsV2TaxSelfCertificationKey, InstitutionDetailsV2TaxSelfCertificationKey> = {
  taxSelfCertification: 'proprietorTaxSelfCertification',
  proprietorTaxSelfCertification: 'taxSelfCertification',
};

/** Sends the customer from the self-certification their legal form doesn't call for, reached by its address, to the one it does */
export const useInstitutionTaxSelfCertificationRedirect = (key: InstitutionDetailsV2TaxSelfCertificationKey) => {
  const onboardingPath = useInstitutionOnboardingBasePath();
  const navigate = useNavigate();
  const { data: institutionDetailsAnswers, isLoading } = useInstitutionDetailsV2Answers();
  const isRedirecting = !isLoading && !getV2OnboardingApplicableDetailsKeys(institutionDetailsAnswers).includes(key);

  useEffect(() => {
    if (isRedirecting) navigate(getV2OnboardingDetailsKeyRoute(onboardingPath, OTHER_TAX_SELF_CERTIFICATION[key]), { replace: true });
  }, [isRedirecting, key, navigate, onboardingPath]);

  return isRedirecting;
};
